import { ApplicationPhotoCacheContext, GalleryCacheContext } from '@/lib/inspiration_cache_context.js';

import {useContext } from "react";
import { getGalleryLink,  galleryRouting, galleriesRouting, getAppPhotoLink, appPhotosRouting } from "@/lib/utils.js";
import Link from 'next/link';


export default function InspirationBreadcrumbs(props) {
  const photoContext =  useContext(ApplicationPhotoCacheContext);
  const galleryContext = useContext(GalleryCacheContext)
  const getLinkForBreadcrumb = (breadcrumb) => {
    if (breadcrumb.path.startsWith('/lex-cms/inspiration/galleries') && galleryContext.items?.length > 0 ){
      return (
       <Link {...galleriesRouting(breadcrumb.path, galleryContext.scroll) }>
          <a >{breadcrumb.name } </a>
       </Link>
         )
    }
    else if(breadcrumb.path.startsWith('/lex-cms/inspiration/application_photos/') && photoContext.items?.length > 0  ) {
      return (
        <Link {...appPhotosRouting(breadcrumb.path, photoContext.scroll) }>
          <a >{breadcrumb.name } </a>
        </Link>
      )
    }
    else if(breadcrumb.path.startsWith('/lex-cms/inspiration/gallery') && galleryContext.items?.length > 0  ) {
      let gallery = {id: breadcrumb.path.split('/').at(-1)  } 
      return (
        <Link {...galleryRouting(gallery) }>
          <a >{breadcrumb.name } </a>
        </Link>
      )
    }
    else {
    return (<a href={breadcrumb.path }>{breadcrumb.name } </a>)
    }
  }
 
  const paths = props.breadcrumbs_path || []
  paths.unshift({path: '/lex-cms/inspiration/index', name: 'Inspiration Home'})
  const lastIndex = paths.length - 1
  return (<div className='lexcms-inspiration-breadcrumbs'>
     <ul> 
       {paths.map((breadcrumb, i) => {
         return ( 
           <li key={i} className={i === lastIndex ? 'active' : ''}> 
             {lastIndex === i &&
             <> {breadcrumb.name}</>
             }


             {lastIndex !== i && 
                 getLinkForBreadcrumb(breadcrumb)

             }
           </li>
         )
       })
       }
     </ul>
    </div>
  )
}
